// Override Settings
var bcSfFilterSettings = {
  general: {
    limit: 48,
    /* Optional */
    loadProductFirst: false,
  },
};

// Declare Templates
var bcSfFilterTemplate = {
  soldOutClass: "sold-out",
  saleClass: "on-sale",
  soldOutLabelHtml: "<div>" + bcSfFilterConfig.label.sold_out + "</div>",
  saleLabelHtml: "<div>" + bcSfFilterConfig.label.sale + "</div>",
  vendorHtml: "<div>{{itemVendorLabel}}</div>",

  // Grid Template
  productGridItemHtml:
    "{{itemLifestyle}}" +
    '<div class="col-6 col-sm-4 col-lg-3 px-0 px-sm-2 prodGridItem" spo-product-{{itemId}}>' +
    '<div class="hoverCTA" style="--border-color: {{borderStyleColor}}">' +
    '<a href="{{itemUrl}}" class="grid__image">' +
    '<div class="first-img">' +
    "{{itemImage}}" +
    "</div>" +
    '<div class="second-img">' +
    '<img width="289" height="385" data-src="{{itemHoverImage}}" class="second-img lazyload" alt="{{ product.featured_image.alt | escape}}">' +
    "</div>" +
    "{{itemFlag}}" +
    '<div name="secomapp-fg-image-{{itemId}}" style="display: none;"> <img src="//cdn.shopify.com/s/files/1/2730/7792/t/2/assets/icon-freegift.png" alt="Free Gift" class="sca-fg-img-label"> </div><div class="sca-fg-cat-list" style="display:none;" name="secomapp-fg-data-{{itemId}}" prod-show="list"> </div>' +
    "</a>" +
    '<div class="prodGridItemText">' +
    '<a href="{{itemUrl}}"><span class="prodTitle">{{itemTitle}}</span>{{itemPrice}}</a>' +
    "{{itemExcerpt}}" +
    '<div class="prodReviewsInline">' +
    '<div class="yotpo-widget-instance" data-yotpo-instance-id="445007"	data-yotpo-product-id="{{itemId}}" data-yotpo-cart-product-id="{{itemId}}" data-yotpo-section-id="collections"></div></div>' +
    "</div>" +
    '<span class="product-price">' +
    "{{itemCart}}" +
    "</span>" +
    //                                   '{{itemExcerpt}}' +
    //                                   '<p class="product-price hideMe">' +

    //                                     '{{itemSoldOut}}' +

    "</div>" +
    "</div>",

  // Pagination Template
  previousActiveHtml: '<li><a href="{{itemUrl}}">&larr;</a></li>',
  previousDisabledHtml: '<li class="disabled"><span>&larr;</span></li>',
  nextActiveHtml: '<li><a href="{{itemUrl}}">&rarr;</a></li>',
  nextDisabledHtml: '<li class="disabled"><span>&rarr;</span></li>',
  pageItemHtml: '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  pageItemSelectedHtml: '<li><span class="active">{{itemTitle}}</span></li>',
  pageItemRemainHtml: "<li><span>{{itemTitle}}</span></li>",
  paginateHtml:
    '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

  // Sorting Template
  //'<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label>
  sortingHtml:
    '<select class="collection-sort__input"><option value = "all" selected="selected">Sort By</option>{{sortingItems}}</select><i class="fal fa-chevron-down selectArrow"></i>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (
  data,
  index,
  totalProduct
) {
  // console.log(data);

  /*** Prepare data ***/
  var images = data.images_info;
  var multiVariant = false;
  var selectShade = false;
  var eGiftCard = false;
  var hideProduct = true;
  (data.price_min *= 100),
    (data.price_max *= 100),
    (data.compare_at_price_min *= 100),
    (data.compare_at_price_max *= 100); // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data["variants"][0];
  if (getParam("variant") !== null && getParam("variant") != "") {
    var paramVariant = data.variants.filter(function (e) {
      return e.id == getParam("variant");
    });
    if (typeof paramVariant[0] !== "undefined") firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data["variants"].length; i++) {
      if (data["variants"][i].available) {
        firstVariant = data["variants"][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/

  //CHECK FOR MULTIPLE VARIANTS
  if (data.variants.length > 1) {
    // if (data.id == "3853613498410") {
    //console.log("total number of variants: " + data.variants.length);
    //console.log("item with multiple variants: " + data.variants[0].title);
    multiVariant = true;
  }

  if (data.id == "3853613498410") {
    //console.log("total number of variants: " + data.variants.length);
    //console.log("item with multiple variants: " + data.variants[0].title);
    selectShade = true;
  }

  if (data.id == "6091291853000") {
    eGiftCard = true;
  }

  if (data.tags.includes("SEARCHANISE_IGNORE")) {
    hideProduct = true;
  }

  // Get Template

  if (data.tags.includes("SEARCHANISE_IGNORE")) {
    var itemHtml = "";
  } else {
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  }

  // Add lifestyle image
  var itemLifestyleHtml = "";
  var dataIndex = index;
  var newBanner = document.location.pathname;
  var newSearch = document.location.search;

  itemHtml = itemHtml.replace(/{{itemLifestyle}}/g, itemLifestyleHtml);

  // Add Image Hover
  var itemHoverImageHtml = "";
  if (images.length > 0) {
    itemHoverImageHtml =
      typeof images[1] !== "undefined"
        ? this.optimizeImage(images[1]["src"], "500x")
        : this.optimizeImage(images[0]["src"], "500x");
  }
  itemHtml = itemHtml.replace(/{{itemHoverImage}}/g, itemHoverImageHtml);

  // Add Image
  var itemImageHtml = "",
    itemThumbUrl =
      images.length > 0
        ? this.optimizeImage(images[0]["src"], "500x")
        : bcSfFilterConfig.general.no_image_url;
  itemImageHtml =
    '<img width="289" height="385" src="' +
    itemThumbUrl +
    '" class="dummy" alt="{{itemTitle}}">';
  itemHtml = itemHtml.replace(/{{itemImage}}/g, itemImageHtml);

  // Add Border Color
  var itemBorderStyleColor = this.getProductMetafield(
    data,
    "accentuate",
    "product_accent_color"
  );
  
  try {
    itemBorderStyleColor = JSON.parse(itemBorderStyleColor);
    if (itemBorderStyleColor instanceof Array) {
      itemBorderStyleColor = itemBorderStyleColor[0];
      itemHtml = itemHtml.replace(/{{borderStyleColor}}/g, itemBorderStyleColor);
    }
  } catch (err) {
    if (itemBorderStyleColor !== null && itemBorderStyleColor.length > 0) {
      itemHtml = itemHtml.replace(/{{borderStyleColor}}/g, itemBorderStyleColor);
    }
  }


  // Add Flag
  var itemFlagHtml = "";
  //     var flag = this.getProductMetafield(data, 'product', 'flag');
  //     if (this.getProductMetafield(data, 'product', 'flag') !== null)
  var flag = localStorage.getItem(data.id + "flag");
  if (flag !== null && flag.length > 0) {
    itemFlagHtml += '<div class="prodFlag">' + flag + "</div>";
  }
  itemHtml = itemHtml.replace(/{{itemFlag}}/g, itemFlagHtml);

  // Add Excerpt
  var itemExcerptHtml = "";
  var excerpt = localStorage.getItem(data.id + "excerpt");
  if (excerpt !== null && excerpt.length > 0) {
    itemExcerptHtml += '<div class="prodExcerpt">' + excerpt + "</div>";
  }
  itemHtml = itemHtml.replace(/{{itemExcerpt}}/g, itemExcerptHtml);

  //     var itemExcerptHtml = '';
  //     if (this.getProductMetafield(data, 'product', 'excerpt') !== null) {
  //     var content = this.getProductMetafield(data, 'product', 'excerpt');
  // //         itemExcerptHtml += '<span class="prodExcerpt">' + this.truncateByChar(content, 35, '...') + '</span>';
  //         itemExcerptHtml += '<p class="prodExcerpt">' + content + '</p>';
  //     }

  // Add Cart
  var itemCartHtml = "";

  /* SELECT VARIANT */
  //if (data.variants.length > 0) {
  if (multiVariant == true) {
    var multiVariantURL = this.buildProductItemUrl(data);
    //console.log("multiVariantURL: " + multiVariantURL);
    itemCartHtml += '<div class="prodGridItemForm AddToCartForm">';
  } else {
    itemCartHtml +=
      '<form action="/cart/add" data-productid="{{itemId}}" method="post" enctype="multipart/form-data" class="AddToCartForm prodGridItemForm">';
  }

  /* END SELECT VARIANT */

  itemCartHtml += '<div class="product-price-box">';
  itemCartHtml +=
    '<select name="id" data-productid="{{itemId}}" id="productSelect" class="product-single__variants visually-hidden">';
  for (var i = 0; i < data.variants.length; i++) {
    if (data.variants[i].available) {
      if (data.variants[i] == firstVariant) {
        itemCartHtml +=
          '<option selected="selected" value="' +
          data.variants[i].id +
          '">' +
          data.variants[i].title +
          " - " +
          this.formatMoney(data.variants[i].price) +
          "</option>";
      } else {
        itemCartHtml +=
          '<option value="' +
          data.variants[i].id +
          '">' +
          data.variants[i].title +
          " - " +
          this.formatMoney(data.variants[i].price) +
          "</option>";
      }
    } else {
      itemCartHtml +=
        '<option disabled="disabled">' +
        data.variants[i].title +
        " - " +
        bcSfFilterConfig.label_basic.sold_out +
        "</option>";
    }
  }
  itemCartHtml += "<select>";
  itemCartHtml += "</div>";
  itemCartHtml += '<div class="cta-quantity">';
  itemCartHtml +=
    '<label for="Quantity" class="quantity-selector" style="visibility: hidden;">Quantity</label>';
  itemCartHtml +=
    '<input type="number" id="Quantity" name="quantity" value="1" min="1" class="quantity-selector visually-hidden">';
  /*DISABLE ADD TO CART IF SOLD OUT*/
  if (soldOut) {
    // console.log(data.title + ' is not avialable');
    itemCartHtml += `<div class="soldOut"><button class="button d-block product-size-label btn custom-notify-me-btn product_${data.id} mb-0" data-swaction="addToWatchlist" data-product-id="${data.id}" data-variant-id="${data.variants[0].id}" data-url="https://slmdskincare.com/products/${data.handle}" style="display: block; margin-bottom: 20px;" name="id" data-sku="${data.variants[0].sku}" value="${data.variants[0].id}" data-button-price="${data.variants[0].price}" type="button">Join Waitlist</button>`;
    itemCartHtml += '</a></div>';
  } else {
    itemCartHtml += '<div class="add-to-cart">';
    itemCartHtml +=
      "<div class=\"product-form-submit-wrap\" itemscope itemprop=\"offers\" itemtype=\"http://schema.org/offers\" onClick=\"ga('send', 'event', 'Button', 'Click', 'Add to Cart Shop All');\">";
    /* SELECT VARIANT */

    if (multiVariant == true && selectShade == false && eGiftCard == false) {
      itemCartHtml += '<a href="{{itemUrl}}">';
      // itemCartHtml += '<button id="AddToCart" type="button" href="{{itemUrl}}" name="select-shade">';
      itemCartHtml +=
        '<span class="AddToCartText" value="Select Shade" class="selectSizeButton">Select Size <span class = "priceRange">' +
        this.formatMoney(data.price_min) +
        " - " +
        this.formatMoney(data.price_max) +
        "</span></span>";
      // itemCartHtml += '</button>';
      itemCartHtml += "</a>";
    } else if (selectShade == true) {
      itemCartHtml += '<a href="{{itemUrl}}">';
      // itemCartHtml += '<button id="AddToCart" type="button" href="{{itemUrl}}" name="select-shade">';
      itemCartHtml +=
        '<span class="AddToCartText" value="Select Shade" class="selectShadeButton">Select Shade</span>';
      // itemCartHtml += '</button>';
      itemCartHtml += "</a>";
    } else if (eGiftCard == true) {
      itemCartHtml += '<a href="{{itemUrl}}">';
      // itemCartHtml += '<button id="AddToCart" type="button" href="{{itemUrl}}" name="select-shade">';
      itemCartHtml += `<span class="AddToCartText" value="Select Amount" class="selectAmountButton">Select Amount ${this.formatMoney(
        data.variants[0].price
      )} -
        ${this.formatMoney(
          data.variants[data.variants.length - 1].price
        )}</span>`;
      // itemCartHtml += '</button>';
      itemCartHtml += "</a>";
    } else if (onSale) {
      itemCartHtml +=
        '<button type="submit" name="add" class="AddToCart" style="visibility: visible;">';
      itemCartHtml +=
        '<span class="AddToCartText" itemprop="price">' +
        bcSfFilterConfig.label_basic.add_to_cart +
        ' <span class = "priceRange">' +
        '<s class="priceRange__actual">' +
        this.formatMoney(data.compare_at_price_min) +
        '</s>' +
        '<span class="priceRange__sale">' +
        this.formatMoney(data.variants[0].price) +
        '</span></span></span>';
      itemCartHtml += '</button>';
    } else {
      itemCartHtml +=
        '<button type="submit" name="add" class="AddToCart" style="visibility: visible;">';
      itemCartHtml +=
        '<span class="AddToCartText" itemprop="price">' +
        bcSfFilterConfig.label_basic.add_to_cart +
        ' <span class = "priceRange">' +
        this.formatMoney(data.variants[0].price) +
        "</span></span>";
      itemCartHtml += "</button>";
    }

    /* END SELECT VARIANT */
    itemCartHtml += "</div>";
    itemCartHtml += "</div>"; //<div class="add-to-cart">
  }
  itemCartHtml += "</div>"; //<div class="cta-quantity">

  /* SELECT VARIANT */
  if (multiVariant == true) {
    itemCartHtml += "</div>";
  } else {
    itemCartHtml += "</form>";
  }

  //}
  /* END SELECT VARIANT */

  //     if (data.variants.length > 0) {

  //       itemCartHtml += '<input type="hidden" name="id" data-productid="{{itemId}}" class="product-select" value="' + data.variants[0]['id'] + '" data-variant-title="' + data.variants[0]['title'] + '" />';
  //       itemCartHtml += '<div class="add-to-cart">';
  //       if (data.available) {
  //       itemCartHtml += '<div class="product-form-submit-wrap">';
  //           itemCartHtml += '<input id="AddToCart" type="submit" value="' + bcSfFilterConfig.label_basic.add_to_cart + '" />';
  //           itemCartHtml += '</div>';
  //           if (onSale) {
  //               if (priceVaries) {
  //           itemCartHtml += '<span class="prod-price">' + bcSfFilterConfig.label_basic.on_sale_from + '</span>';
  //                   itemCartHtml = itemCartHtml.replace(/{{ price }}/g, this.formatMoney(data.price_min));
  //               } else {
  //                   itemCartHtml += '<strong>' + bcSfFilterConfig.label_basic.product.on_sale + '</strong>';
  //                   itemCartHtml += '<span class="prod-price">' + this.formatMoney(data.price_min) + '</span>';
  //               }
  //           } else {
  //             if (priceVaries) {
  //           itemCartHtml += '<span class="prod-price">' + bcSfFilterConfig.label_basic.from + '</span>';
  //                   itemCartHtml = itemCartHtml.replace(/{{ price }}/g, this.formatMoney(data.price_min));
  //               } else {
  //                   itemCartHtml += '<span class="prod-price">' + this.formatMoney(data.price_min) + '</span>';
  //               }
  //           }
  //       } else {
  //           itemCartHtml += '<strong class="soldOut">Sold Out</strong>';
  //       }
  //       itemCartHtml += '</div>';

  //     }

  //   	if (onSale) {
  //       itemCartHtml = '';
  //       itemCartHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label_basic.regular_price + '</span>';
  //       itemCartHtml += '<br><s>' + this.formatMoney(data.compare_at_price_min) + '</s>';
  //       itemCartHtml += '<form class="product-form" action="/cart/add" data-productid="{{itemId}}"  method="post">';
  //       if (data.variants.length > 1) {
  //         itemCartHtml += '<div class="product-options">';
  //         itemCartHtml += '<select name="id" data-productid="{{itemId}}" id="product-select" class="product-select">';
  //         for (var i = 0; i < data.variants.length; i++) {
  //           if (data.variants[i] == firstVariant) {
  //             itemCartHtml += '<option selected="selected" value="' + data.variants[i].id + '">' + data.variants[i].title + ' - ' + this.formatMoney(data.variants[i].price) + '</option>';
  //           } else {
  //             itemCartHtml += '<option value="' + data.variants[i].id + '">' + data.variants[i].title + ' - ' + this.formatMoney(data.variants[i].price) + '</option>';
  //           }
  //         }
  //         itemCartHtml += '<select>';
  //         itemCartHtml += '</div>';
  //       } else {
  //         itemCartHtml += '<input type="hidden" name="id" data-productid="{{itemId}}" class="product-select" value="' + data.variants[0].id + '" data-variant-title="' + data.variants[0].title + '" />';
  //       }
  //       itemCartHtml += '<div class="add-to-cart">';
  //       if (data.available) {
  //         itemCartHtml += '<div class="product-form-submit-wrap">';
  //         itemCartHtml += '<input type="submit" value="' + bcSfFilterConfig.label_basic.add_to_cart + '" />';
  //         itemCartHtml += '</div>';
  //       } else {
  //         itemCartHtml += '<strong class="soldOut">Sold Out</strong>';
  //       }
  //       itemCartHtml += '</div>';
  //       itemCartHtml += '</form>';
  //     }

  itemHtml = itemHtml.replace(/{{itemCart}}/g, itemCartHtml);

  // Add Sold Out label
  var itemSoldOutHtml = "";
  if (soldOut) {
  }
  itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, itemSoldOutHtml);

  // Add Price
  var itemPriceHtml = "";

  var baseVariantPrice = data["variants"][0].price;
  itemPriceHtml +=
    '<span class="visually-hidden">' +
    bcSfFilterConfig.label_basic.regular_price +
    "</span>";
  //itemPriceHtml += '<span class="prodPrice"><span id="ProductPrice" itemprop="price" content="' + this.formatMoney(baseVariantPrice) + '">' + this.formatMoney(baseVariantPrice) + '</span></span>'
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

  return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (data) {
  // // Add Description
  // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  // // Truncate by word
  // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
  // // Truncate by character
  // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
  // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function (data) {
  for (var k in data) {
    // Featured image
    if (data["images_info"] > 0) {
      data[k]["featured_image"] = data["images_info"][0];
    } else {
      data[k]["featured_image"] = { width: "", height: "", aspect_ratio: 0 };
    }

    // Add Options
    var optionsArr = [];
    for (var i in data[k]["options_with_values"]) {
      optionsArr.push(data[k]["options_with_values"][i]["name"]);
    }
    data[k]["options"] = optionsArr;

    // Customize variants
    for (var i in data[k]["variants"]) {
      var variantOptionArr = [];
      var count = 1;
      var variant = data[k]["variants"][i];
      // Add Options
      var variantOptions = variant["merged_options"];
      if (Array.isArray(variantOptions)) {
        for (var j = 0; j < variantOptions.length; j++) {
          var temp = variantOptions[j].split(":");
          data[k]["variants"][i]["option" + (parseInt(j) + 1)] = temp[1];
          data[k]["variants"][i]["option_" + temp[0]] = temp[1];
          variantOptionArr.push(temp[1]);
        }
        data[k]["variants"][i]["options"] = variantOptionArr;
      }
      data[k]["variants"][i]["compare_at_price"] =
        parseFloat(data[k]["variants"][i]["compare_at_price"]) * 100;
      data[k]["variants"][i]["price"] =
        parseFloat(data[k]["variants"][i]["price"]) * 100;
    }

    // Add Description
    data[k]["description"] = data[k]["body_html"];
  }
  return data;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
  if (this.getSettingValue("general.paginationType") == "default") {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    //console.log("totalProduct test: " + totalProduct);
    // If it has only one page, clear Pagination
    if (totalPage == 1) {
      jQ(this.selector.bottomPagination).html("");
      return false;
    }

    if (this.getSettingValue("general.paginationType") == "default") {
      var paginationHtml = bcSfFilterTemplate.paginateHtml;

      // Build Previous
      var previousHtml =
        currentPage > 1
          ? bcSfFilterTemplate.previousActiveHtml
          : bcSfFilterTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(
        /{{itemUrl}}/g,
        this.buildToolbarLink("page", currentPage, currentPage - 1)
      );
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml =
        currentPage < totalPage
          ? bcSfFilterTemplate.nextActiveHtml
          : bcSfFilterTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(
        /{{itemUrl}}/g,
        this.buildToolbarLink("page", currentPage, currentPage + 1)
      );
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (
        var iBefore = currentPage - 1;
        iBefore > currentPage - 3 && iBefore > 0;
        iBefore--
      ) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift("...");
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (
        var iAfter = currentPage + 1;
        iAfter < currentPage + 3 && iAfter <= totalPage;
        iAfter++
      ) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push("...");
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = "";
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == "...") {
          pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml +=
            pageArr[iPage] == currentPage
              ? bcSfFilterTemplate.pageItemSelectedHtml
              : bcSfFilterTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(
          /{{itemUrl}}/g,
          this.buildToolbarLink("page", currentPage, pageArr[iPage])
        );
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

      jQ(this.selector.bottomPagination).html(paginationHtml);
    }
  }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
  if (bcSfFilterTemplate.hasOwnProperty("sortingHtml")) {
    jQ(this.selector.topSorting).html("");
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = "";
      for (var k in sortingArr) {
        sortingItemsHtml +=
          '<option value="' + k + '">' + sortingArr[k] + "</option>";
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(
        /{{sortingItems}}/g,
        sortingItemsHtml
      );
      jQ(this.selector.topSorting).html(html);

      // Set current value
      jQ(this.selector.topSorting + " select").val(this.queryParams.sort);
    }
  }
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
  // Intergrate Pre-order App
  var spoProductData = "",
    spoProductVariant = "";
  for (var i = 0; i < data.length; i++) {
    spoProductData = {
      id: data[i].id,
      handle: data[i].handle,
      title: data[i].title,
      variants: [],
    };

    for (var j = 0; j < data[i].variants.length; j++) {
      spoProductVariant = {
        id: data[i].variants[j]["id"],
        title: data[i].variants[j]["title"],
        inventory_quantity: data[i].variants[j]["inventory_quantity"],
        inventory_policy: data[i].variants[j]["inventory_policy"],
        inventory_management: data[i].variants[j]["inventory_management"],
      };
      spoProductData.variants.push(spoProductVariant);
    }
    // console.log(spoProductData);
  }
  //spoProduct.run(spoProductData, SPOParams.collection);
  // console.log(spoProductData);
};

BCSfFilter.prototype.buildFilterOptionSingleList = function (
  data,
  filterTreeId
) {
  // Sort values
  if (
    data.hasOwnProperty("values") &&
    (data.valueType == "all" ||
      this.getSettingValue("general.sortManualValues") ||
      (data.valueType != "all" && data.sortManualValues))
  )
    data.values = this.sortFilterOptionValue(data);
  // Build content
  var itemsContent = "";
  var fOType = data.filterType,
    fODisplayType = data.displayType,
    fOSelectType = data.selectType,
    fOId = data.filterOptionId,
    fOLabel = data.label;
  // Display Collection "All"
  if (data.filterType == "collection" && data.activeCollectionAll) {
    var checkExistCollection = this.findIndexArray(
      "all",
      data.values,
      "handle"
    );
    if (checkExistCollection == -1) {
      var collectionAll = {
        doc_count: null,
        handle: "all",
        key: typeof this.collectionId != "undefined" ? this.collectionId : 0,
        label: this.getSettingValue("label.collectionAll"),
        tags: null,
      };
      data.values.unshift(collectionAll);
    }
  }
  // Loop through each option values
  for (var k in data.values) {
    itemsContent += this.buildFilterOptionSingleListData(
      fOType,
      fOId,
      fOLabel,
      fODisplayType,
      fOSelectType,
      data["values"][k],
      data
    );
  }
  // Get Template & Append to Filter Tree
  if (itemsContent != "") {
    var html = this.getTemplate("filterOptionSingleList");
    html = html.replace(/{{itemList}}/g, itemsContent);
    this.buildFilterOption(html, data, filterTreeId);
  }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
  jQ('.bc-sf-filter-option-item[data-value="all"')
    .find(".bc-sf-filter-option-value")
    .text("All");
  jQ('.bc-sf-filter-option-item[data-value="all"')
    .find(".bc-sf-filter-option-amount")
    .hide();
};

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
  var self = bcsffilter;
  var ext = typeof ext !== "undefined" ? ext : "png";
  var version = typeof version !== "undefined" ? version : "1";
  var prIndex = self.fileUrl.lastIndexOf("?");
  if (prIndex > 0) {
    var filePath = self.fileUrl.substring(0, prIndex);
  } else {
    var filePath = self.fileUrl;
  }
  filePath += fileName + "." + ext + "?v=" + version;
  return filePath;
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements = function () {
  var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
    isSafari = /Safari/.test(navigator.userAgent),
    isBackButton =
      window.performance &&
      window.performance.navigation &&
      2 == window.performance.navigation.type;
  if (!(isiOS && isSafari && isBackButton)) {
    var self = this,
      url = window.location.href.split("?")[0],
      searchQuery =
        self.isSearchPage() && self.queryParams.hasOwnProperty("q")
          ? "&q=" + self.queryParams.q
          : "";
    window.location.replace(url + "?view=bc-original" + searchQuery);
  }
};

BCSfFilter.prototype.getFilterData = function (eventType, errorCount) {
  function BCSend(eventType, errorCount) {
    var self = bcsffilter;
    var errorCount = typeof errorCount !== "undefined" ? errorCount : 0;
    self.showLoading();
    if (typeof self.buildPlaceholderProductList == "function") {
      self.buildPlaceholderProductList(eventType);
    }
    self.beforeGetFilterData(eventType);
    self.prepareRequestParams(eventType);
    self.queryParams["callback"] = "BCSfFilterCallback";
    self.queryParams["event_type"] = eventType;
    var url = self.isSearchPage()
      ? self.getApiUrl("search")
      : self.getApiUrl("filter");
    var script = document.createElement("script");
    script.type = "text/javascript";
    var timestamp = new Date().getTime();
    script.src = url + "?t=" + timestamp + "&" + jQ.param(self.queryParams);
    script.id = "bc-sf-filter-script";
    script.async = true;
    var resendAPITimer, resendAPIDuration;
    resendAPIDuration = 2e3;
    script.addEventListener("error", function (e) {
      if (typeof document.getElementById(script.id).remove == "function") {
        document.getElementById(script.id).remove();
      } else {
        document.getElementById(script.id).outerHTML = "";
      }
      if (errorCount < 3) {
        errorCount++;
        if (resendAPITimer) {
          clearTimeout(resendAPITimer);
        }
        resendAPITimer = setTimeout(
          self.getFilterData("resend", errorCount),
          resendAPIDuration
        );
      } else {
        self.buildDefaultElements(eventType);
      }
    });
    document.getElementsByTagName("head")[0].appendChild(script);
    script.onload = function () {
      if (typeof document.getElementById(script.id).remove == "function") {
        document.getElementById(script.id).remove();
      } else {
        document.getElementById(script.id).outerHTML = "";
      }
    };
  }
  this.requestFilter(BCSend, eventType, errorCount);
};
BCSfFilter.prototype.requestFilter = function (
  sendFunc,
  eventType,
  errorCount
) {
  sendFunc(eventType, errorCount);
};

/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem = function (
  html,
  iLabel,
  iValue,
  fOType,
  fOId,
  fOLabel,
  fODisplayType,
  fOSelectType,
  fOItemValue,
  fOData
) {
  var keepValuesStatic = fOData.hasOwnProperty("keepValuesStatic")
    ? fOData.keepValuesStatic
    : false;
  if (
    fOType == "review_ratings" &&
    this.getSettingValue("general.ratingSelectionStyle") == "text"
  ) {
    var title = this.getReviewRatingsLabel(fOItemValue.from);
  } else {
    var title = this.customizeFilterOptionLabel(iLabel, fOData.prefix, fOType);
  }
  if (keepValuesStatic === true) var productNumber = null;
  else
    var productNumber = fOItemValue.hasOwnProperty("doc_count")
      ? fOItemValue.doc_count
      : 0;
  html = html.replace(
    /{{itemLabel}}/g,
    this.buildFilterOptionLabel(iLabel, productNumber, fOData)
  );
  html = html.replace(
    /{{itemLink}}/g,
    this.buildFilterOptionLink(
      fOId,
      iValue,
      fOType,
      fODisplayType,
      fOSelectType,
      keepValuesStatic
    )
  );
  html = html.replace(/{{itemValue}}/g, encodeURIParamValue(iValue));
  html = html.replace(/{{itemTitle}}/g, title);
  html = html.replace(
    /{{itemFunc}}/g,
    "onInteractWithFilterOptionValue(event, this, '" +
      fOType +
      "', '" +
      fODisplayType +
      "', '" +
      fOSelectType +
      "', '" +
      keepValuesStatic +
      "')"
  );
  html = this.checkFilterOptionSelected(fOId, iValue, fOType, fODisplayType)
    ? html.replace(/{{itemSelected}}/g, "selected")
    : html.replace(/{{itemSelected}}/g, "");
  var htmlElement = jQ(html);
  htmlElement.children().attr({
    "data-id": fOId,
    "data-value": encodeURIParamValue(iValue),
    "data-parent-label": fOLabel,
    "data-title": title,
    "data-count": productNumber,
  });
  if (fOType != "collection") {
    htmlElement.children().attr("rel", "nofollow");
  }
  if (fOType == "collection")
    htmlElement.children().attr("data-collection-scope", fOItemValue.key);
  return jQ(htmlElement)[0].outerHTML;
};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
(BCSfFilter.prototype.initFilter = function () {
  return this.isBadUrl()
    ? void (window.location.href = window.location.pathname)
    : (this.updateApiParams(!1), void this.getFilterData("init"));
}),
  (BCSfFilter.prototype.isBadUrl = function () {
    try {
      var t = decodeURIComponent(window.location.search).split("&"),
        e = !1;
      if (t.length > 0)
        for (var i = 0; i < t.length; i++) {
          var n = t[i],
            a = (n.match(/</g) || []).length,
            r = (n.match(/>/g) || []).length,
            o = (n.match(/alert\(/g) || []).length,
            h = (n.match(/execCommand/g) || []).length;
          if ((a > 0 && r > 0) || a > 1 || r > 1 || o || h) {
            e = !0;
            break;
          }
        }
      return e;
    } catch (l) {
      return !0;
    }
  });
/* End patch boost-010 run 2 */

/* start-boost-custom */
/* #boost-114078: customize filter params with plus characters */
var prepareRequestParams = BCSfFilter.prototype.prepareRequestParams;

BCSfFilter.prototype.prepareRequestParams = function (eventType) {
  prepareRequestParams.call(this, eventType);

  for (var key of Object.keys(this.queryParams)) {
    if (key.startsWith("pf_")) {
      if (Array.isArray(this.queryParams[key])) {
        this.queryParams[key] = this.queryParams[key].map((value) =>
          value.replace(/\+/g, " ")
        );
      } else {
        this.queryParams[key] = this.queryParams[key].replace(/\+/g, " ");
      }
    }
  }
};

/**
 * Request API for Filter Data
 * @param  {[type]} eventType  [description]
 * @param  {[type]} errorCount [description]
 * @return {[type]}            [description]
 */
BCSfFilter.prototype.getFilterData = function (eventType, errorCount) {
  function BCSend(eventType, errorCount) {
    var self = bcsffilter;
    var errorCount = typeof errorCount !== "undefined" ? errorCount : 0;
    // Show Loading icon
    self.showLoading();
    //build Placeholder for product list
    self.buildPlaceholderProductList(eventType);
    // Action before requesting API
    self.beforeGetFilterData(eventType);
    // Prepare request params
    self.prepareRequestParams(eventType);
    self.queryParams["callback"] = "BCSfFilterCallback";
    self.queryParams["event_type"] = eventType;
    // Prepare url
    var url = self.isSearchPage()
      ? self.getApiUrl("search")
      : self.getApiUrl("filter");
    // Create request
    var script = document.createElement("script");
    script.type = "text/javascript";
    var timestamp = new Date().getTime();

    var params = jQ.param(self.queryParams);
    params = params.replace(/\+/g, "%20");

    script.src = url + "?t=" + timestamp + "&" + params;
    script.id = "bc-sf-filter-script";
    script.async = true;
    var resendAPITimer,
      resendAPIDuration = 2000;
    script.addEventListener("error", function (e) {
      if (typeof document.getElementById(script.id).remove == "function") {
        // If support is found
        document.getElementById(script.id).remove();
      } else {
        // If not
        document.getElementById(script.id).outerHTML = "";
      }
      // Resend API 2 times when got the error
      if (errorCount < 2) {
        errorCount++;
        if (resendAPITimer) {
          clearTimeout(resendAPITimer);
        }
        resendAPITimer = setTimeout(
          self.getFilterData("resend", errorCount),
          resendAPIDuration
        );
      } else {
        self.buildDefaultElements(eventType);
      }
    });
    // Append the script element to the HEAD section.
    document.getElementsByTagName("head")[0].appendChild(script);
    script.onload = function () {
      if (typeof document.getElementById(script.id).remove == "function") {
        // If support is found
        document.getElementById(script.id).remove();
      } else {
        // If not
        document.getElementById(script.id).outerHTML = "";
      }
    };
  }

  this.requestFilter(BCSend, eventType, errorCount);
};
/* end-boost-custom */
